import { Table as AntdTable } from 'antd';
import type { TableProps as AntdTableProps, TablePaginationConfig } from 'antd';
import cx from 'classnames';

import styles from './Table.module.sass';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface TableProps<RecordType = any> extends AntdTableProps<RecordType> {
  isOuterMobile?: boolean;
  paginationConfig?: TablePaginationConfig;
}

const Table = ({
  isOuterMobile = true,
  paginationConfig,
  ...props
}: TableProps) => {
  const classes = cx(styles.table, {
    [styles.outerMobile]: isOuterMobile,
  });

  return (
    <AntdTable
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      size="middle"
      showSorterTooltip={false}
      pagination={paginationConfig || false}
      bordered={false}
      className={classes}
    />
  );
};

export default Table;
